import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import FleetServiceFiltersBar from '../../fleet/services/FleetServiceFiltersBar';
import { FleetServiceList } from '../../fleet/services/FleetServiceList';

function FleetServicesPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <FleetServiceFiltersBar />
      <FleetServiceList />
    </FullContainer>
  );
}

export default FleetServicesPage;
